import BaseRegulation, {BaseRegulationParams} from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import _ from '../../../../utils/underscore';
import {GNWP_SOURCES} from '../../../../../../app-react/services/gnwp/gnwp-consts';
import {TEMP_ACCOUNT_STATUS} from "../../../../../../common/const/temp_account_status";
import { REGULATION_STATUS_ID_MAP } from '../../regulation_const';

interface SpainRegulationParams extends BaseRegulationParams {
    tempAccountMessageHelper?: TempAccountMessageRegulationHelper;
}
const TEMP_ACCOUNT_PARAMS:any = {
    [TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED]: {
        status: TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED,
        messageKey: 'spa_temp_account_message',
        footerMessageKey: 'spa_temp_account_footer_message'
    },
    [TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION]: {
        status: TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION,
        messageKey: 'spa_temp_account_verify_message'
    },
    [TEMP_ACCOUNT_STATUS.APPROVED]: {
        status: TEMP_ACCOUNT_STATUS.APPROVED
    }
};
export default class SpainRegulation extends BaseRegulation {

    static CLASS = 'SpainRegulation';
    private _tempAccountMessageHelper: TempAccountMessageRegulationHelper;
    private _msgParams: any;


    public init(params: SpainRegulationParams): void {
        super.init(params);
        this._tempAccountMessageHelper = params.tempAccountMessageHelper || TempAccountMessageRegulationHelper.create({
           serviceFactory: this.serviceFactory
        });
    }

    public showTempAccountMessage():void {
        let accountData:any = this.serviceFactory.userService().getAccountData();
        let isDocUploadRequired:boolean = accountData.IsDocUploadRequired;
        let daysLeft:number = accountData.DaysToUploadDocument;
        let status:string = TEMP_ACCOUNT_STATUS.APPROVED;
        if (accountData.RegulationStatusId === REGULATION_STATUS_ID_MAP.PENDING_VERIFICATION || accountData.RegulationStatusId === REGULATION_STATUS_ID_MAP.PENDING_DOCUMENTS) {
            if (_.isNullOrUndefined(daysLeft)) {
                status = TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION;
            } else if (daysLeft >= 0) {
                status = TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED;
            }
        }
        this._msgParams = Object.assign({}, {daysLeft: daysLeft}, TEMP_ACCOUNT_PARAMS[status]);
        this.logger.info('ES User status ' + status);
        if (isDocUploadRequired) {
            this.serviceFactory.externalLinksProxyService().openUploadDocumentFromMyAccount();
        } else {
            this._tempAccountMessageHelper.showTempAccountMessage({
                paramsFunc: this.getTempAccountParams.bind(this)
            });
        }
    }

    showResponsibleIcons() {
        return false;
    }

    private getTempAccountParams(): any{
        return this._msgParams;
    }

    public getTempAccountGnwpSource(){
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

    public isAnonymousPlayAllowed() : boolean {
        return this.serviceFactory.oAuth2Service().isAuthorized();
    }
}